export class SuperI{
  id:BigInteger;
  codigo:String;
  nombre:String;
}
